// import DataListPasien from "../services/DataList";
class Pasien {
  status() {
    const st: Array<object> = [
      {
        text: "Semua",
        value: "-1"
      },
      {
        text: "Belum Selesai",
        value: "0"
      },
      {
        text: "Selesai",
        value: "1"
      },
      {
        text: "Batal Periksa",
        value: "2"
      }
    ];
    return st;
  }

  // pilihStatus(a, tgl) {
  //   const dt = DataListPasien.getPasienByStatus(a, tgl)
  //   return dt
  // }

  // pilihStatus(kdPoli, tgl, status) {
  //   const dt = DataListPasien.getPasienFilter(kdPoli,tgl,status)
  //   return dt
  // }
}

export default new Pasien();
